<script lang="ts" setup>
    const props = defineProps<{ blok: SpotifyWidgetStoryblok }>();

    const builtSpotifyURL = parseSpotifyURL(props.blok.spotifyLink);

    const link = computed(() => {
        if (!builtSpotifyURL.validLink) {
            return undefined;
        }

        return `https://open.spotify.com/embed/${builtSpotifyURL.type}/${builtSpotifyURL.id}${
            props.blok.video && builtSpotifyURL.type !== 'playlist' ? '/video' : ''
        }`;
    });
</script>
<template>
    <div v-if="builtSpotifyURL.validLink">
        <ClientOnly>
            <CookieConsent service-key="spotify">
                <iframe
                    title="Spotify Widget"
                    class="frame"
                    :class="builtSpotifyURL.type !== 'playlist' && !blok.video ? '' : 'aspect'"
                    :src="link"
                    width="100%"
                    allowfullscreen="true"
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                    loading="lazy"
                ></iframe>
            </CookieConsent>
        </ClientOnly>
    </div>

    <template v-if="!builtSpotifyURL.validLink">
        <Note type="error">
            <p>
                <strong>{{ $t('general.error') }}</strong>
            </p>
            <p>{{ $t('errors.invalidSpotifyURL') }}</p>
        </Note>
    </template>
</template>
<style scoped>
    .frame {
        max-width: 100%;
        height: fit-content;
        min-height: 100%;
    }
    .aspect {
        aspect-ratio: 16/9;
    }
</style>
